
import {aiApi} from './ai'

export const getSocialAccountsApi = aiApi.injectEndpoints({
  endpoints: (builder) => ({
    getSocialAccounts: builder.query({
      query: () => '/social/accounts',
      providesTags: ['SocialAccount'],
    }),
    

  }),
  overrideExisting: false,
})

export const { useGetSocialAccountsQuery, usePrefetch } = getSocialAccountsApi